import React from 'react'
import { useEffect } from 'react';
import './services.css';

import services from '../data/services';




const Services = () => {
  return (
    <><section className="top-section services">
      <div className="overlay">
        <div className="column">
          <h1>Our Services</h1>
        </div>
      </div>
    </section>
    <section className="services-section-2">
      <div className="text-container">
        <h2>What Make Us... Well, Us.</h2>
        <p>
          At Renew Engineering, we provide <strong>comprehensive mechanical engineering solutions</strong>, from <strong>CAD design</strong> and <strong>precision machining to  tooling, molding, and fabrication</strong>. Our expertise in <strong>production automation, consulting, and advanced manufacturing</strong> techniques ensures optimized efficiency, accuracy, and innovation. Whether you need <strong>custom tooling, high-precision molds, or automated systems</strong>, we deliver tailored solutions to drive your success.
        </p>
      </div>
    </section>
    <section  className="services-section-3">

      {services.map((service) => (
        <div id={service.sid} key={service.id} className="service-container">
          <div className="column text-container">
            <div className="line"></div>
            <h5>0{service.id}</h5>
            <h2>{service.title}</h2>
            <p dangerouslySetInnerHTML={{__html: service.text}}></p>
          </div>
          <div className="column image-container">
            <img src={service.image}/>
          </div>
        </div>
      ))}
      
    </section>

    </>
  )
}

export default Services